export default {

  namespaced: true,

  state: () => ({


  }),

  mutations: {

  },

  actions: {

    async getOrder({ commit }, id) {

      const data = await axios.get('/erp/order/order/' + id);

      return data;
    },

    async getOrderReport({ commit }, params) {
      const data = await axios.get('/erp/order/report', { params: params });
      return data;
    },
    async postOrder({ commit }, params) {
      const data = await axios.post('/erp/order/order', params);
      return data;
    },
    async getOrderOfProductsBySalesman({ commit }, params) {
      const data = await axios.get('/erp/order/report/order-of-products-by-salesman', { params: params });
      return data;
    },
  }
}
